<template>
    <pp-modal v-model="showModal" :mask-closable="false" width="488">
        <p slot="header" class="modalHead"  style="border-bottom:0;">
            <span>{{modalheader}}</span>
        </p>
        <div class="modalContent">
            <p>{{modalcontent}}</p>
        </div>
        <div slot="footer" class="textright">
            <pp-button class="pp-btn pp-btn-primary pp-btn-spec" @click="skipeTo">{{modalbtn}}</pp-button>
        </div>
    </pp-modal>
</template>

<script>
    import {
        Component,
        Vue,
        Prop,
        Watch
    } from 'vue-property-decorator'
    
    export default {
        name: 'successModal',
        props: {
            tourl: "",
            modalcontent: "",
            modalheader: "",
            modalbtn: "",
            accountStatus:""
        },
        mounted() {},
        data() {
            return {
                showModal: false,
            }
        },
        methods: {
            show() {
                this.showModal = true
            },
            skipeTo() {
                if(this.accountStatus){//参数
                    this.$replace(this.tourl + '?accountStatus='+this.accountStatus)
                }else{
                    this.$replace(this.tourl)
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .modalHead {
        color: #000;
        font-size: 20px;
        text-align: left
    }
    
    .modalContent {
        text-align: left;
        font-size: 14px;
    }
</style>
